import { render, staticRenderFns } from "./TintometricoSyncMaquinaInfo.vue?vue&type=template&id=c260faa8"
import script from "./TintometricoSyncMaquinaInfo.vue?vue&type=script&lang=js"
export * from "./TintometricoSyncMaquinaInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports